import i18n from 'i18n'

const ShowSuccessMsg = () => {
  const isFrench = i18n.language.startsWith('fr')

  return (
    <div
      className='d-flex align-items-center justify-content-center px-3 py-10'
      style={{minHeight: '70vh'}}
    >
      <div className='card border-0 shadow-sm w-100' style={{maxWidth: '850px'}} aria-live='polite'>
        <div className='card-body text-center p-6 p-md-10'>
          <div
            className='d-inline-flex align-items-center justify-content-center rounded-circle bg-light-success mb-6'
            style={{width: '90px', height: '90px'}}
          >
            <i className='fas fa-check-circle text-success' style={{fontSize: '52px'}} />
          </div>

          <h4 className='fw-bold text-gray-900 mb-5'>
            {isFrench
              ? ' Nous vous remercions pour l’envoi de votre dossier de candidature à SWISS UMEF University - Campus de Dakar.'
              : 'Thank you for submitting your application to SWISS UMEF University - Dakar Campus.'}
          </h4>

          <div className='fs-5 text-gray-700 lh-lg'>
            {isFrench ? (
              <>
                <p className='mb-4'>
                  Votre demande a bien été reçue et enregistrée dans notre système.
                </p>
              </>
            ) : (
              <>
                <p className='mb-4'>
                  Your application has been successfully received and recorded in our system.
                </p>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default ShowSuccessMsg
